/**
 * Cross-app links for the shared header: the portal root (hub root SPA) and
 * the Admin SPA. Both live at the hub's `APP_BASE_URL`, which the hub reports
 * in GET /settings/branding. Without it (same-origin deploy, or unset) the
 * links stay relative so they resolve in place.
 */
export function portalLinks(input) {
    const origin = input.appBaseUrl?.replace(/\/+$/, '') || undefined;
    const portalHref = origin ? `${origin}/` : '/';
    const adminHref = input.isAdmin ? (origin ? `${origin}/admin` : '/admin/') : undefined;
    return { portalHref, adminHref };
}
//# sourceMappingURL=portal-links.js.map